import { render } from "./ArrowDown.vue?vue&type=template&id=3b550b2d&scoped=true"
import script from "./ArrowDown.vue?vue&type=script&lang=js"
export * from "./ArrowDown.vue?vue&type=script&lang=js"

import "./ArrowDown.vue?vue&type=style&index=0&id=3b550b2d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b550b2d"]])

export default __exports__